import { render, staticRenderFns } from "./DeleteBackup.vue?vue&type=template&id=eceb0370&"
import script from "./DeleteBackup.vue?vue&type=script&lang=js&"
export * from "./DeleteBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports